exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offline-badge[data-v-b19954c0] {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n}\n", ""]);

// exports
